import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { localUsers } from "../../util/localDbUtil";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import Avatar from "@mui/material/Avatar";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/AddCircle";
import CheckIcon from "@mui/icons-material/Check";
import { useTheme } from "@mui/material/styles";
import { useAuthentication } from "../../providers/AuthenticationProvider";
import ListItemIcon from "@mui/material/ListItemIcon";
import { useEffect, useState } from "react";
import { axiosHttp } from "../../wrapper/AxiosWrapper";
import { HttpStatusCode } from "axios";

const SwitchUserModalView = (props) => {
    const [reloadUsers, setReloadUsers] = useState(false);
    const [inProgress, setInProgress] = useState(false);
    const [switchRequestedUser, setSwitchRequestedUser] = useState();
    const [users, setUsers] = useState();

    const activeUser = localUsers.getActiveUser();
    const { login, logout, logedInSuccess } = useAuthentication();

    const theme = useTheme();

    useEffect(() => {
        let usermap = localUsers.getAllUsers();
        let userList = [activeUser];
        Object.values(usermap).map((user) => {
            if (user.id != activeUser.id) {
                userList.push(user);
            }
        })
        setUsers(userList);
    }, [reloadUsers])

    const handleAddAccount = () => {
        props.close();
        login();
    }

    const signOutUser = (user) => {
        setInProgress(true);
        let signOutUrl = activeUser.id === user.userId ? "/api/dss/v1/signOut" : "/api/dss/v1/signOutUser";
        let postData = activeUser.id === user.userId ? null : { sessionId: user.sessionId }
        axiosHttp.post(signOutUrl, postData)
            .then((res) => {
                if (activeUser.id === user.id) {
                    logout();
                    props.close();
                } else {
                    localUsers.deleteUser(user.id);
                    setReloadUsers(!reloadUsers);
                }
            })
            .catch((error) => { })
            .then((res) => {
                setInProgress(false);
            })
    }

    const switchUser = async (user) => {

        if (activeUser.id === user.id) {
            return;
        }

        setSwitchRequestedUser(user);
        try {
            //signOut the current active user
            await axiosHttp.post("/api/dss/v1/signOut");

            //SignIn with existing token (Refresh token);
            const signInResponse = await axiosHttp.post("/api/dss/v1/signIn?refresh=true", { authToken: user.authToken });
            if (signInResponse.data.status === HttpStatusCode.Ok) {
                await logedInSuccess(signInResponse.data.content);
                props.close();
            } else {//problem with refresh token. Required manual login
                props.close();
                login();
            }
            setSwitchRequestedUser(null);
        } catch (e) {

        }

    }
    return (
        <Dialog open={props.open} onClose={props.close} fullWidth maxWidth="sm"
            sx={{
                "& .MuiDialog-paper": {
                    borderRadius: 4
                },
            }}
        >
            <DialogTitle>Switch Accounts</DialogTitle>
            <DialogContent >
                <Box sx={{ width: '100%', typography: 'body1' }}>
                    <List dense sx={{ width: '100%', }}>
                        {users && Object.values(users).map((user) => (
                            <ListItem
                                key={user.id}
                                secondaryAction={
                                    <Button onClick={() => signOutUser(user)} loading={inProgress || (user.id === switchRequestedUser?.id)}
                                        sx={{ textTransform: "none" }}
                                        component={Link}
                                        edge="end">Sign out</Button>
                                }
                                disablePadding
                            >
                                <ListItemButton onClick={() => switchUser(user)}>
                                    <ListItemIcon>
                                        {user.id === activeUser.id
                                            ? <Box sx={{
                                                p: .2,
                                                borderRadius: "50%",
                                                //border: "2px solid " + user.avatar
                                            }}>
                                                <Avatar src={user.profilePictureUrl} alt={user.userName} sx={{ backgroundColor: user.avatar }} />
                                            </Box>
                                            : <Avatar src={user.profilePictureUrl} alt={user.userName} sx={{ backgroundColor: user.avatar }} />
                                        }

                                    </ListItemIcon>

                                    <ListItemText
                                        primary={
                                            <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                                                <Typography >{user.displayName}</Typography> 
                                                {user.id === activeUser.id && <CheckIcon />}
                                            </Box>
                                        }
                                        secondary={<Typography sx={{ opacity: .6 }}>{user.userName}</Typography>}
                                    />
                                </ListItemButton>
                            </ListItem>
                        ))}
                        <ListItem disablePadding>
                            <ListItemButton onClick={handleAddAccount}>
                                <ListItemIcon>
                                    <Avatar sx={{backgroundColor:theme.palette.primary.main}}><AddIcon /></Avatar>
                                </ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={{ color: theme.palette.primary.main }}>Add Account</Typography>}
                                    secondary={<Typography sx={{ opacity: .6 }}>Sign in to add a new account.</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                    </List>
                </Box>
            </DialogContent>
        </Dialog>

    );
};

export default SwitchUserModalView;